<template>
    <div id="demo-basic-card" class="margin-top-graphic">
        <div id="dashboard-analytics">
            <div class="vx-row">
                <vx-card :headerPadding="true" class="p-1 pt-1">
                <div class="vx-row">
                    <div class="vx-col md:w-3/12 selected-dropdown w-full mt-1">
                    <vs-dropdown id="dropdown-left" vs-custom-content vs-trigger-click class="cursor-pointer w-full label-selected pr-4">
                        <label for="" class="ml-3 font-bold">{{ $t("articleBookmark.project") }}:</label>
                        <vs-button type="border" icon-pack="feather" icon="icon-clipboard" style="margin-left:10px" class="text-size w-full mt-1">
                        {{ labelGroup }}
                        </vs-button>
                        <vs-dropdown-menu class="" style="width:250px;max-height:20rem">
                        <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown p-0">
                            <vs-dropdown-item
                            v-for="(item, index) in optionGroupTopics"
                            :key="index"
                            style="overflow:auto;max-height:200px"
                            @click="searchByTopicGroup(item)"  >
                            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                                <span class="ml-2 text-size" style="vertical-align:middle">
                                {{ item.label }}
                                </span>
                            </li>
                            </vs-dropdown-item>
                        </VuePerfectScrollbar>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                    </div>

                    <div class="vx-col md:w-3/12 selected-dropdown w-full mt-1">
                    <vs-dropdown id="dropdown-left" vs-custom-content vs-trigger-click class="cursor-pointer w-full label-selected pr-4">
                        <label for="" class="ml-3 font-bold">{{ $t("topic") }}:</label>
                        <vs-button
                        type="border"
                        icon-pack="feather"
                        icon="icon-clipboard"
                        style="margin-left:10px"
                        class="text-size w-full mt-1">
                        {{ labelTopic }}
                        </vs-button>
                        <vs-dropdown-menu class="" style="width:250px;max-height:20rem">
                        <VuePerfectScrollbar
                            ref="scrollDialog"
                            class="scroll-area--nofications-dropdown p-0">
                            <vs-dropdown-item
                            v-for="(item, index) in optionTopics"
                            :key="index"
                            style="overflow:auto;max-height:200px"
                            @click="searchByTopic(item)">
                            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                                <span
                                class="ml-2 text-size"
                                style="vertical-align:middle">
                                {{ item.topicName }}
                                </span>
                            </li>
                            </vs-dropdown-item>
                        </VuePerfectScrollbar>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                    </div>

                    <div
                    class="vx-col mb-2 md:w-4/12 selected-dropdown w-full mt-1 pl-8"
                    style="display:grid">
                    <label for="" class="font-bold">
                        {{ $t("time") }}:
                    </label>
                    <date-range-picker
                        class="w-full"
                        ref="picker"
                        :locale-data="{ format: 'dd/mm/yyyy' }"
                        :opens="'left'"
                        @update="initScreen"
                        v-model="dateRange">
                    </date-range-picker>
                    </div>
                    <div class="vx-col md:w-2/12 w-full mt-4 pl-8">
                        <vs-button
                        class="w-full"
                        icon="icon-download"
                        icon-pack="feather"
                        style="border-radius:10px">
                        {{ $t("download") }}
                        </vs-button>
                    </div>
                </div>
                </vx-card>
            </div>
            <gender :dateRange="dateRange" :topicId="topicId" :topicGroupId="topicGroupId" :refreshData="refresh"></gender>
            <!-- <shade-by-home-town :dateRange="dateRange"></shade-by-home-town> -->
        </div>
    </div>
</template>

<script>
import DateRangePicker from "@/layouts/components/vue2-daterange-picker/components/DateRangePicker.vue";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import VuePerfectScrollbar from "vue-perfect-scrollbar";

import Gender from './card-demo-graphic/Gender.vue';
import ShadeByHomeTown from './card-demo-graphic/ShadeByHomeTown.vue';
export default {
    components: {
        DateRangePicker,
        VuePerfectScrollbar,
        Gender,
        ShadeByHomeTown
    },
    data(){
        return {
            optionTopics: [],
            optionGroupTopics: [],
            labelGroup: this.$t('all'),
            topicGroupId: null,
            topicId: null,
            labelTopic: this.$t('all'),
            listTopics: [],
            refresh: 0,

            dateRange: {
                endDate: new Date(),
                startDate: (() => {
                let date = new Date();
                date.setDate(date.getDate() - 6);
                date.setHours(0, 0, 0);
                return date;
                })()
            }

        }
    },
    methods: {
        getTopicGroups: function() {
      return new Promise((resolve, reject) => {
        let type = this.$route.query.type
        if(type){
          this.$business
            .post(`/topic-group/find-by-conditions/${type}`, {})
            .then(res => {
              this.optionGroupTopics = res.data;
              if (this.optionGroupTopics.length > 0) {
                this.optionGroupTopics = this.optionGroupTopics.map(el => {
                  return {
                    label: el.groupName,
                    value: el.id
                  };
                });
                this.optionGroupTopics.unshift({ label: "Khác", value: null });
                this.optionGroupTopics.sort(function(a, b) {
                  return b.value - a.value;
                });
                let selecteAll = { label: "Tất cả", value: null };
                this.optionGroupTopics = [selecteAll].concat(
                  this.optionGroupTopics
                );
              }
              this.findByTopicGroup(res.data);
              resolve();
            })
            .catch(() => reject());
        }
        else {
          this.$business
            .post("/topic-group/find-by-conditions", {})
            .then(res => {
              this.optionGroupTopics = res.data;
              if (this.optionGroupTopics.length > 0) {
                this.optionGroupTopics = this.optionGroupTopics.map(el => {
                  return {
                    label: el.groupName,
                    value: el.id
                  };
                });
                this.optionGroupTopics.unshift({ label: "Khác", value: null });
                this.optionGroupTopics.sort(function(a, b) {
                  return b.value - a.value;
                });
                let selecteAll = { label: "Tất cả", value: null };
                this.optionGroupTopics = [selecteAll].concat(
                  this.optionGroupTopics
                );
              }
              this.findByTopicGroup(res.data);
              resolve();
            })
            .catch(() => reject());
        }

      });
    },
    getTopic() {
      return new Promise((resolve, reject) => {
        let conditions = {};
      let type = this.$route.query.type;
        if(type) {
            this.$business
            .post(`/topic/find-by-conditions/${type}`, conditions)
            .then(topics => {
                this.$business
                .post(`share-topic/get-all-share`, conditions)
                .then(res => {
                    let listTopics = [
                    ...topics.data,
                    ...res.data.filter(item => item.status === 1)
                    ];
                    this.optionTopics = listTopics;
                    this.listTopics = listTopics;
                    let result = null;
                    let arrGroupTopic = this.optionGroupTopics;
                    arrGroupTopic.forEach(filter => {
                    result = this.optionTopics.filter(
                        topic => topic.topicGroupId == filter.value
                    );
                    if (result < 1) {
                        let index = arrGroupTopic.indexOf(filter);
                        this.optionGroupTopics.splice(index, 1);
                    }
                    });
                    this.optionTopics.forEach(item => {
                    if (item.favourite) {
                        this.searchByTopic(item);
                    }
                    if (item.topicName && item.topicName.length > 23) {
                        item.topicName = item.topicName.slice(0, 23) + "...";
                    }
                    if (
                        !this.optionGroupTopics.find(
                        el => el.value == item.topicGroupId
                        )
                    ) {
                        item.isOther = true;
                    } else {
                        item.isOther = false;
                    }
                    });
                    let selectedAll = { topicName: "Tất cả", id: null };
                    if (this.topicGroupId) {
                    this.optionTopics = this.optionTopics.filter(
                        topic => topic.topicGroupId ==this.topicGroupId
                    );
                    }
                    this.optionTopics = [selectedAll].concat(this.optionTopics);
                    this.initScreen();
                });
            });
        }
        else {
            this.$business
            .post("/topic/find-by-conditions", conditions)
            .then(topics => {
                this.$business
                .post(`share-topic/get-all-share`, conditions)
                .then(res => {
                    let a = this;
                    let listTopics = [
                    ...topics.data,
                    ...res.data.filter(item => item.status === 1)
                    ];
                    this.optionTopics = listTopics;
                    this.listTopics = listTopics;
                    let result = null;
                    let arrGroupTopic = this.optionGroupTopics;
                    arrGroupTopic.forEach(filter => {
                    result = this.optionTopics.filter(
                        topic => topic.topicGroupId == filter.value
                    );
                    if (result < 1) {
                        let index = arrGroupTopic.indexOf(filter);
                        this.optionGroupTopics.splice(index, 1);
                    }
                    });
                    this.optionTopics.forEach(item => {
                    if (item.favourite) {
                        this.searchByTopic(item);
                    }
                    if (item.topicName && item.topicName.length > 23) {
                        item.topicName = item.topicName.slice(0, 23) + "...";
                    }
                    if (
                        !this.optionGroupTopics.find(
                        el => el.value == item.topicGroupId
                        )
                    ) {
                        item.isOther = true;
                    } else {
                        item.isOther = false;
                    }
                    });
                    let selectedAll = { topicName: "Tất cả", id: null };
                    if (this.topicGroupId) {
                    this.optionTopics = this.optionTopics.filter(
                        topic => topic.topicGroupId ==this.topicGroupId
                    );
                    }
                    this.optionTopics = [selectedAll].concat(this.optionTopics);
                    this.initScreen();
                    this.findByTopic(this.optionTopics);
                });
            });
            }
        })
        },
        findByTopicGroup: function(topicGroups){
            let groupId = this.$route.query.groupId;
            if (groupId) {
                let topicGroup = topicGroups.find(group => group.id == groupId);
                if (topicGroup) {
                this.topicGroupId = groupId;
                this.labelGroup = topicGroup.groupName;
                }
                else {
                this.topicGroupId = null;
                this.labelGroup = this.$t('all');
                }
            }
        },
        findByTopic: function(topic){
            let id = this.$route.query.id;
            if (id) {
                this.topicId = id;
                let result = topic.find(topic => topic.id == id);
                this.labelTopic = result.topicName;
            }
        },
        searchByTopic: function(item) {
            this.topicGroupId = null;
            this.labelTopic = item.topicName;
            this.topicId = item.id;
            // this.selectedTopic = item;
            this.initScreen();
        },
        searchByTopicGroup: function(item) {
            let selectedAll = { topicName: "Tất cả", id: null };
            this.optionTopics = [selectedAll].concat(this.optionTopics);
            let listTopics = this.listTopics;
            this.labelGroup = item.label;
            this.topicGroupId = item.value;
            this.topicId = null;
            this.labelTopic = 'Tất cả'
            this.initScreen();
            if (item.value)
                return (this.optionTopics = [selectedAll].concat(listTopics.filter(
                el => el.topicGroupId == item.value
                )));
            if (item.label.includes("Khác") && item.value == null)
                return (this.optionTopics = [selectedAll].concat(listTopics.filter(el => el.isOther)));
            if (item.label.includes("Tất cả") && item.value == null)
                return (this.optionTopics = this.listTopics);
        },
        initScreen(){
            this.refresh += 1;
        }
    },
    async created(){
        this.initScreen();
        this.getTopicGroups().then(() => {
            this.getTopic();
        });
    }
}
</script>

<style lang="scss">
.label-selected {
  text-align: left;
}
.vue-daterange-picker .ranges {
  float: right;
  border-left: 1px solid #ddd;
}
.daterangepicker {
  border-left: none !important;
}
@media (max-width: 1440px) {
  .statistic {
    padding: 0 !important;
  }
}
.reportrange-text {
  border-radius: 10px;
  min-width: 200px;
}
.margin-top-graphic {
    margin-top: -16px;
}
</style>